<main class="text-black placeholder:text-gray-900 bengali-400">
  <router-outlet />
  <app-toast></app-toast>
  <app-confirm></app-confirm>
</main>
